import React, { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Space, Typography } from "antd";
import Header from "components/layout/Header";

import OrganizationForm from "../OrganizationForm";

import { useAddOrganization } from "./hooks";

const OrganizationAdd: FC = () => {
  const { loading, handleSubmit, initialValues, form, onValuesChange } =
    useAddOrganization();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Create a new organization" />
        </Typography.Title>
      </Header>
      <Space />
      <OrganizationForm
        loading={loading}
        submitHandler={handleSubmit}
        initialValues={initialValues}
        form={form}
        onValuesChange={onValuesChange}
      />
    </>
  );
};

export default OrganizationAdd;
